/**  Представление отображения графа */
import React from 'react'
import { Spin } from 'antd';

import ApiUtils from '../../virtuoso/ApiUtils';

import SPARQLGraph from '../../components/graph/SPARQLGraph';
import OWLGraph from '../../components/graph/OWLGraph';
import AnyGraph from '../../components/graph/AnyGraph';

import { makeSettings } from '../../utils/viewsUtil'



const isAnyInSettings = settings =>{
  return (settings && settings.settings && settings.settings.extra_options && (settings.settings.extra_options.type == "any"));
}
/** Представление обеспечивает загрузку данных с использованием SPARQL запроса, 
 * и отборажение его с использованием SPARQLGraph 
 * */
class GraphComponent extends React.Component {

  constructor(props) {
    super(props);
    //view - идентификатор представления
    //description - описание представления
    //settings - параметры для графа
    //loaded - флаг загрузки
		this.state = {view: null, description: null, settings: null, loaded: false};
  }
  
	componentDidMount(){
    this.loadContent();
	}

  static getDerivedStateFromProps(props, state) {
    //console.log("GraphComponent.js static getDerivedStateFromProps(props, state)", props, state);
    if ((props.settings && (JSON.stringify(props.settings) !== JSON.stringify(state.settings))) ||
        (JSON.stringify(props.view) != JSON.stringify(state.view))) {
      return {
        view: null, description: null, settings: null, loaded: false
      };
    }
    return null; // Return null to indicate no change to state.
  }

  loadContent(){
    if (this.state.loaded) return;
    //console.log("GraphComponent.js loadContent()", this);
    //Параметры заданы стразу
    if (this.props.settings){
      const {endpoint, graph, sparql} = this.props.settings;
      const options = {headers:{'Content-type': 'application/json'}, endpointUrl: endpoint};
      return ApiUtils.fetch(sparql, graph, {}, options)
        .then(response => {
          //console.log("content", response);
          this.setState({ content: response, loaded: true, settings: this.props.settings, view: this.props.view});
        })  
    }
    //Первый шаг - загрузка  описания view
    if (!this.state.description){
      const {view, iri, model} = this.props;
      return model.getView(view.id)
        .then(response => {
          const description = response.view;
          return {description, settings: makeSettings(description)};
      //Второй шаг - загрузка содержимого
      }).then(response =>{
        const {description, settings} = response;
        const {endpoint, graph, sparql} = settings;
        const options = {headers:{'Content-type': 'application/json'}, endpointUrl: endpoint};
        //console.log("GraphComponent.js loadContent() 2", this, response, sparql, graph, options);
        ApiUtils.register_endpointUrl(endpoint);
        return ApiUtils.fetch(sparql, graph, {}, options)
          .then(content => {
            this.setState({ description, content, loaded: true, settings, view});
          })  
      })
    }
  }

  
  render(){
    console.log(this); 
    //console.log(JSON.stringify(this.state.settings));console.log(JSON.stringify(this.state.content));
    if (!this.state.loaded)
      return(<div className="text-center"><Spin size="large"/><div>Загрузка данных для графа...</div></div>)
    if ((this.props.type == "owl") || (this.state.settings.type=="owl"))
      return (<OWLGraph content={this.state.content} settings={this.state.settings}/>)
      if ((this.props.type == "any") || (this.state.settings.type=="any") || isAnyInSettings(this.state.settings))
        return (<AnyGraph content={this.state.content} settings={this.state.settings}/>)
		return (
      <SPARQLGraph content={this.state.content} settings={this.state.settings}/>
    )
  }
}

export default GraphComponent;

